var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "white"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1837_3405)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.02011 6C10.2156 6.34955 17.7173 6.03972 22.9933 6.03972L23 7.77954C17.6838 7.7001 10.2358 7.30288 5 7.58888L5.02011 6Z",
  fill: "black",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.02011 13.3485C11.0134 13.3723 17 13.3406 22.9933 13.2532V14.85C19.9966 14.7626 16.9933 14.707 13.9966 14.6593C11 14.6117 7.99665 14.5402 5 14.5322L5.01341 13.3406H5.02011V13.3485Z",
  fill: "black",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.02011 20.2999C10.2223 20.2602 17.7173 20.4111 22.9933 20.4111V22.0079C19.8156 21.992 12.562 21.9285 9.49832 21.9603C7.99665 21.9444 6.50168 21.9364 5 21.8967L5.02011 20.3078V20.2999Z",
  fill: "black",
  stroke: "black"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1837_3405"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 16,
  fill: "white",
  transform: "translate(5 6)"
})))));
export default SvgIconMenu;